<template>
  <el-dialog
    title="通知对象明细"
    :visible.sync="visible"
    width="70%"
    @close="$emit('update:show', false)"
  >
    <div
      style="font-weight: bold"
      v-if="model.user_names && model.user_names.length > 0"
    >
      内部人员
    </div>
    <div class="mb-20">
      <el-tag
        disable-transitions
        size="small"
        class="mt-5 mr-5"
        v-for="user in model.user_names"
        :key="user"
        >{{ user }}</el-tag
      >
    </div>

    <div
      style="font-weight: bold"
      v-if="model.dealer_names && model.dealer_names.length > 0"
    >
      中间商
    </div>
    <div>
      <el-tag
        disable-transitions
        size="small"
        class="mt-5 mr-5"
        v-for="dealer in model.dealer_names"
        :key="dealer"
        >{{ dealer }}</el-tag
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: this.show,
    }
  },
}
</script>